import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { TTicketingUser } from '../types/ticketing-user.type';

export const DeleteTicketingUserValidationSchema = z.object({
  userId: z.string({ message: 'User ID is required' }).min(1),
});
export type TDeleteTicketingUserValidation = z.infer<typeof DeleteTicketingUserValidationSchema>;
export type TDeleteTicketingUserPayload = TDeleteTicketingUserValidation;
export type TDeleteTicketingUserResponse = ApiResponse<TTicketingUser>;

export const deleteTicketingUser = (payload: TDeleteTicketingUserPayload): Promise<TDeleteTicketingUserResponse> => {
  const url = `/user-ticketing/manage/${payload.userId}`;

  return axiosInstance.delete(url);
};

/**
 * Use Delete Ticketing User React-Query Hook
 */
type UseDeleteTicketingUserMutationOptions = {
  mutationConfig?: TypedMutationConfig<typeof deleteTicketingUser, AxiosErrorCustom>;
};

export const useDeleteTicketingUserMutation = ({ mutationConfig }: UseDeleteTicketingUserMutationOptions) => {
  const { ...restConfig } = mutationConfig ?? {};

  return useMutation({
    mutationFn: deleteTicketingUser,
    ...restConfig,
  });
};
